export default "__VITE_ASSET__BR1tE5d___"